import React from "react";
import { cn } from "../lib/helpers";
import ImageG from "./image-g";
import PortableText from "./portableText";

import * as styles from "../styles/components/project-item.module.css";

interface ImageAsset {
  asset?: {
    _id?: string;
  };
  alt?: string;
}

interface Project {
  title?: string;
  location?: string;
  _rawCopy?: any[];
  image?: ImageAsset;
}

interface ProjectItemProps {
  project?: Project;
  theme?: string;
}

const ProjectItem: React.FC<ProjectItemProps> = ({ project, theme }) => {
  // Destructure your data for easier access
  const { 
    title,
    location,
    _rawCopy,
    image
  } = project || {};

  return (
    <div className={cn(styles.root, styles[theme])}>
      {image?.asset && (
        <div className={styles.image}>
          <ImageG node={image} />
        </div>
      )}

      {(title || location || _rawCopy) && (
        <div className={styles.text}>
          {title && (<h3 className={cn("h5", styles.title)}>{title}</h3>)}
          {(location || _rawCopy) && (
            <div className={cn("body-small", styles.desc)}>
              {location && (<div className={styles.location}>{location}</div>)}
              {_rawCopy && (<div className={cn("entry-content", styles.copy, theme)}><PortableText blocks={_rawCopy} theme={theme} /></div>)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectItem;
